import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714","key":"svg-0"}]]

/**
 * IconBrandGravatar
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZ3JhdmF0YXIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUuNjQgNS42MzJhOSA5IDAgMSAwIDYuMzYgLTIuNjMydjcuNzE0IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-gravatar
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandGravatar = createReactComponent('outline', 'brand-gravatar', 'BrandGravatar', __iconNode);

export default IconBrandGravatar;